import * as FuncionesServices from "../../utils/funciones-services";

export const obtenerRoles = async () => {
    return FuncionesServices.procesarRespuesta({
        url: process.env.REACT_APP_WS_GET_ROLES_USUARIO,
        method: 'GET',
        headers: new Headers({
            'Authorization'             : 'Bearer ' + FuncionesServices.getAccessToken(),
            'Iam-id-token'              : 'Bearer ' + FuncionesServices.getIamToken(),
            'idTransaccion'             : FuncionesServices.generarCorrelativo(),
            'Ocp-Apim-Subscription-Key' : process.env.REACT_APP_SUSCRIPTION_KEY,
            'correlationId'             : FuncionesServices.generarCorrelativo(),
            'nombreAplicacion'           : process.env.REACT_APP_NOMBRE_APLICACION
        })
    })
}

export const obtenerDatosUsuario = async () => {
    return FuncionesServices.procesarRespuesta({
        url: process.env.REACT_APP_WS_GET_DATOS_USUARIO,
        method: 'GET',
        headers: new Headers({
            'Authorization'             : 'Bearer ' + FuncionesServices.getAccessToken(),
            'Iam-id-token'              : 'Bearer ' + FuncionesServices.getIamToken(),
            'idTransaccion'             : FuncionesServices.generarCorrelativo(),
            'Ocp-Apim-Subscription-Key' : process.env.REACT_APP_SUSCRIPTION_KEY,
            'correlationId'             : FuncionesServices.generarCorrelativo(),
            'nombreAplicacion'           : process.env.REACT_APP_NOMBRE_APLICACION
        })
    })
}

export const obtenerIntermediario = async (idIntermediario) => {
    let atributos = [{ campo: 'idIntermediario', valor: idIntermediario }]
    return FuncionesServices.procesarRespuesta({
        url: FuncionesServices.reemplazarUrlServicio(process.env.REACT_APP_WS_GET_INTERMEDIARIO, atributos),
        method: 'GET',
        headers: new Headers({
            'Ocp-Apim-Subscription-Key' : process.env.REACT_APP_SUSCRIPTION_KEY,
            'Authorization'             : 'Bearer ' + FuncionesServices.getAccessToken(),
            'Iam-id-token'              : 'Bearer ' + FuncionesServices.getIamToken(),
            'transactionId'             : FuncionesServices.generarCorrelativo(),
            'correlationId'             : FuncionesServices.generarCorrelativo(),
            'businessProcess'           : process.env.REACT_APP_BUSINESS_PROCESS,
            'applicationName'           : process.env.REACT_APP_NOMBRE_APLICACION,
            'applicationUser'           : 'test'
        })
    })
}